var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"side"},[_c('transition',{attrs:{"name":"fade"}},[_c('div',{staticClass:"left"},[_vm._t("left-content")],2)]),_c('div',{staticClass:"right"},[_vm._t("right-content")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }